import http from "./http_common";


class AccountService {

  QueryString(payload) {
    return Object.keys(payload).filter(key => key && payload[key] !== '').map((key) => key + "=" + encodeURIComponent(payload[key])).join("&");
  }


  addAccount(payload) {
    return http.post('/accountMaster/', payload);
  }

  editAccount(payload, id) {
    return http.put(`/accountMaster/${id}`, payload);
  }

  AccountActiveInactive(payload){
    return http.put('/accountMaster/update/status',payload);
  }


  AccountList(payload) {
    const queryString = this.QueryString(payload);
    return http.get(`/accountMaster/list/filter?${queryString}`);
  }

   AccountLogo(payload) {
    const queryString = this.QueryString(payload);
    return http.get(`/accountMaster/getLogo?${queryString}`);
  }

  AccountListTotalCount(payload) {
    const queryString = this.QueryString(payload);
    return http.get(`/accountMaster/accountMasterCountStatus?${queryString}`);
  }

  AccountFilter(payload) {
    const queryString = Object.entries(payload)
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return http.get(`/accountMaster/list/filter?${queryString}`);
  }

  getBillingReport(payload) {
    var queryString = this.QueryString(payload)
    return http.get(`/billingTransaction/list/filter?${queryString}`);
  }

  getTotalReportsCount(payload) {
    if (payload === undefined) {
      return http.get(`/billingTransaction/getBillingTransactionCountStatus`);
    }
    var queryString = this.QueryString(payload);
    return http.get(`/billingTransaction/getBillingTransactionCountStatus?${queryString}`);
  }

  getOrderReport(payload) {
    var queryString = this.QueryString(payload)
    return http.get(`/billingTransaction/getDrugAndLabAmount?${queryString}`);
  }

  getTotalOrderReportsCount(payload) {
    if (payload === undefined) {
      return http.get(`/billingTransaction/getDrugAndLabCount`);
    }
    var queryString = this.QueryString(payload);
    return http.get(`/billingTransaction/getDrugAndLabCount?${queryString}`);
  }

  getDashBoardDetails(payload) {
    var queryString = this.QueryString(payload);
    return http.get(`/admin-dashboard/getDetails?${queryString}`);
  }
}

export default new AccountService();